import { Badge } from "@/components/ui/badge";
import { Zap, Wind, Target, Snowflake, Fan, Droplets, ClipboardList } from "lucide-react";

const ServiceSetsSection = () => {
  const serviceSets = [
    {
      title: "VRF AC Services",
      icon: <Zap className="h-6 w-6" />,
      keywords: [
        "VRF AC Installation Surat",
        "VRF System Repair",
        "VRF Air Conditioning",
        "Variable Refrigerant Flow",
        "VRF AC Service Near Me",
        "Commercial VRF Installation",
        "VRF AC Maintenance",
        "VRF System AMC",
        "VRF Outdoor Unit Service",
        "VRF AC Gas Filling",
        "Daikin VRF Service",
        "Mitsubishi VRF Installation",
        "VRF AC Service",
        "VRF AC Repair"
      ]
    },
    {
      title: "Ductable AC Services",
      icon: <Wind className="h-6 w-6" />,
      keywords: [
        "Ductable AC Installation",
        "Ductable AC Repair Surat",
        "Ducted Air Conditioning",
        "Central AC Installation",
        "Ductable AC Service",
        "Commercial Ductable AC",
        "Duct AC Maintenance",
        "Ductable AC AMC",
        "Concealed Duct AC",
        "Ductable AC Gas Refill",
        "Office AC Ducting",
        "Showroom Ductable AC"
      ]
    },
    {
      title: "Cassette AC Services",
      icon: <Target className="h-6 w-6" />,
      keywords: [
        "Cassette AC Installation",
        "Ceiling Cassette AC",
        "Cassette AC Repair Surat",
        "4-Way Cassette AC",
        "Cassette AC Service",
        "Commercial Cassette AC",
        "Cassette AC Maintenance",
        "Cassette AC AMC",
        "Restaurant Cassette AC",
        "Office Cassette AC",
        "Cassette AC Gas Filling",
        "False Ceiling AC Installation"
      ]
    },
    {
      title: "Split AC Services",
      icon: <Snowflake className="h-6 w-6" />,
      keywords: [
        "Split AC Installation Surat",
        "Split AC Repair Near Me",
        "Split AC Service",
        "Inverter AC Installation",
        "Split AC Gas Filling",
        "Split AC Maintenance",
        "Split AC AMC Surat",
        "Window AC to Split",
        "Split AC Compressor Repair",
        "Split AC PCB Repair",
        "Residential AC Service",
        "Home AC Installation",
        "AC Service",
        "AC Repair"
      ]
    },
    {
      title: "AHU AC Services",
      icon: <Fan className="h-6 w-6" />,
      keywords: [
        "AHU Installation Surat",
        "Air Handling Unit Service",
        "AHU Repair",
        "AHU Maintenance",
        "Industrial AHU",
        "Commercial AHU",
        "AHU AMC Contract",
        "VRF AHU Service",
        "Ductable AHU",
        "Mini AHU Installation",
        "AHU Filter Replacement",
        "AHU Coil Cleaning"
      ]
    },
    {
      title: "Air Chiller Services",
      icon: <Droplets className="h-6 w-6" />,
      keywords: [
        "Air Chiller Installation Surat",
        "Water Cooled Chiller",
        "Air Cooled Chiller",
        "Industrial Chiller Service",
        "Chiller AMC Surat",
        "Chiller Repair",
        "Chiller Plant Maintenance",
        "Screw & Scroll Chiller",
        "Chiller Commissioning",
        "Process Cooling Chiller",
        "Chiller Energy Optimization",
        "Air Chiller"
      ]
    },
    {
      title: "HVAC Audit & Tools",
      icon: <ClipboardList className="h-6 w-6" />,
      keywords: [
        "HVAC Audit Services",
        "HVAC Energy Audit Surat",
        "Indoor Air Quality Audit",
        "Energy Conservation Measures (ECM)",
        "AC Tonnage Calculator",
        "Cooling Load Calculation",
        "kW/TR Efficiency Audit",
        "BMS & Controls Audit",
        "ASHRAE 62.1 Ventilation Audit",
        "IAQ Testing (CO2, PM2.5, TVOC)",
        "HVAC Commissioning",
        "VRF & Ductable Audit"
      ]
    }
  ];

  return (
    <section className="py-16 bg-gray-900" data-testid="service-sets-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <Badge className="bg-amber-500/20 text-amber-400 border-amber-500/30 mb-4">Service Sets</Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Complete HVAC Solutions in Surat
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            Professional AC installation, repair, service and maintenance for all types of air conditioning systems
          </p>
        </div>

        {/* Service Sets Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {serviceSets.map((service, index) => (
            <div
              key={index}
              className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700 hover:border-amber-500/50 transition-all duration-300 hover:scale-105"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-gradient-to-br from-amber-500 to-yellow-500 p-2 rounded-lg text-black">
                  {service.icon}
                </div>
                <h3 className="text-lg font-semibold text-white">{service.title}</h3>
              </div>
              
              <div className="flex flex-wrap gap-2">
                {service.keywords.map((keyword, idx) => (
                  <span
                    key={idx}
                    className="text-xs bg-gray-700/50 text-gray-300 px-2 py-1 rounded-full hover:bg-amber-500/20 hover:text-amber-400 transition-colors cursor-default"
                  >
                    {keyword}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Additional SEO Keywords */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm">
            Serving Surat, Gujarat | AC Service | AC Repair | VRF | Ductable | Air Chiller | AHU | Cassette & Split AC | AC Tonnage Calculator | HVAC Energy Audit Services | Indoor Air Quality Audit | HVAC Contractor | Air Conditioning Expert | 24/7 Emergency AC Repair | Industrial Cooling Solutions | Commercial AC Installation | Residential AC Service
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServiceSetsSection;
